// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"pop","432":"catalogo","779":"agregarNuevoPop"}[chunkId] + "." + {"272":"4a1b7f85","432":"ec3a465e","779":"a024c756"}[chunkId] + ".css";
};